import { Environment } from '../interfaces';

export const DEFAULT_ENVIRONMENT: Environment = {
  name: 'qa8',
  value: 'qa8'
};

export const EMPTY_ENVIRONMENT: Environment = {
  name: '',
  value: ''
};
